import { computed, inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
  
} from '@ngrx/signals';
import { NewUserService, UserData } from 'data/service/user-service';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';
import { getCurrentUser } from '@aws-amplify/auth';
import { NewProductStore } from './new-product.store';
 
type UserState = {
  currentUser: { 
    id: string; 
    name: string; 
    email: string, 
    sub:string,
    avatar?:string 
  }|null;
  userCache: UserData[];
};

const initialState: UserState = {
  currentUser: null,
  userCache: [],
};

export const NewUserStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),
  withStorageSync({
    key: 'user-cache',
    autoSync: true,
    select: ((state: UserState) => ({
      userCache: state.userCache,
    })) as (state: any) => Partial<any>,
  }),

  withMethods((store, 
    service = inject(NewUserService),
    newProductStore = inject(NewProductStore)
  ) => ({
    // getUserById(userId: string) {
    //   return computed(() => {
    //     return store.userCache().find(u => u.id === userId);
    //   });
    // },

    getByUserId(userId: string) {
      return computed(() => store.userCache().find(u => u.id === userId));
    },

    async loadUsers(userIds: string[]) {
      const userIdsNotInCache = userIds.filter(id => !store.userCache().some(u => u.id === id));
      if (userIdsNotInCache.length === 0) return;
      const users = await service.getMultipleUsers(userIdsNotInCache);
      if (users.length === 0) return;
      patchState(store, {
        userCache: [...store.userCache(), ...users],
      });
    },

    async isAuthenticated() {
      try { 
        const user = await getCurrentUser();
        const currentUser = store.currentUser();
        if(!currentUser || currentUser.sub !== user.userId) {
          const userDataFromToken = await service.loadUserFromToken();
          patchState(store, {
            currentUser: userDataFromToken,
          });
          //Load user entitlements
          newProductStore.loadUserEntitlements();
        }
        return true;
      } catch (e) {
        return false;
      }
    },
    async resetCurrentUser() {
      patchState(store, {
        currentUser: null
      });
    },
    

  }))
);

